import React from "react";
import { useIntl } from "umi";
import { Button } from "tea-component";

import comming_soon from '@/pages/dashboard/assets/svg/comming_soon.svg'
import './index.scss'

interface ICommingSoonProps {
  onClick?: () => void;
  showButton?: boolean;
  text?: string;
}

export default (props: ICommingSoonProps) => {
  const { showButton = false, onClick, text = '' } = props;
  const {formatMessage} = useIntl();

  return (
    <div className="dbd-comming-soon-box">
      <img className="dbd-comming-soon-img" src={comming_soon} />
      <div className="dbd-comming-soon-text">{formatMessage({id:'common_comming'})}</div>
      {showButton && <Button
        style={{
          marginTop: '10px'
        }}
        type="primary"
        onClick={onClick}
      >
        {text}
      </Button>}
    </div>
  )
}
